import { useParams, useSearchParams } from "react-router-dom";
import CategorySection from "../../Components/Naray8/CategoriesSection";
import HeaderStory from "../../Components/Naray8/HeaderStory";

export default function Discover() {
  const { slug } = useParams() ?? {};
  const [searchParams] = useSearchParams();
  const selectedStatus = searchParams.get('status');
  const searchQuery = searchParams.get('q');

  return (
    <div className="w-full transition-all duration-500">
      <div className="bg-customGray rounded-2xl w-full mx-auto max-w-7xl">
        <div className="mx-auto px-4 py-6">
          <HeaderStory />
          <div className="flex flex-col space-y-4">
            <section className="bg-[#353530]">
              <CategorySection categorySlug={slug} status={selectedStatus} searchQuery={searchQuery} />
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
